var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var debounce = require('debounce');
var device = require('./device.js');

function SVGShapes() {
  this.init();
}

SVGShapes.prototype.init = function() {
  var RoughEdges = [];

  // $('.vsc-button.has-rough-edges, .wpslsubmit.has-rough-edges').each(function() {
  //   $(this).removeClass('has-rough-edges').find('svg').remove();
  // });

  $('.vsc-button, .wpslsubmit, [data-rough-edge], .acf-form-submit').each(function() {
    var el = this;

    if(!$(el).hasClass('has-rough-edges')) {
      var roughEdge = new RoughEdgeSVG(el);

      if(roughEdge.svg) {
        $(el).data('edgeSVG', roughEdge).append(roughEdge.svg).addClass('has-rough-edges');

        RoughEdges.push(roughEdge);
      }
    } else {
      RoughEdges.push($(this).data('edgeSVG'));
    }
  });

  $(window).off('resize.vsc-svg-shapes load.vsc-svg-shapes')
    .on('resize.vsc-svg-shapes load.vsc-svg-shapes', debounce(function() {
      RoughEdges.forEach(function(edge) {
        edge.resize();
      });
    }, 200));
}

module.exports = SVGShapes;

var svgID = 0;
var ns = 'http://www.w3.org/2000/svg';

function RoughEdgeSVG(element) {
  this.el = element;
  this.$el = $(this.el)

  this.className = this.el.getAttribute('data-rough-edge-class');
  this.mode = this.el.getAttribute('data-rough-edge') || 'all';
  this.mask = this.el.getAttribute('data-rough-edge-mask');

  if((this.el.offsetWidth <= 0) || (this.mask && device.browser === 'ie')) {
    return false;
  }

  if(this.mode === 'all') {
    this.color = '#DA8B15';
  } else if(this.mask) {
    this.color = '#FFFFFF';
  } else {
    this.color = '#FEFEFB'
  }

  var filterID = 'roughEdgeFilter'+svgID;
  var maskID = 'roughEdgeMask'+svgID;

  var svg = document.createElementNS(ns, 'svg');
  var defs = document.createElementNS(ns, 'defs');
  var filter = document.createElementNS(ns, 'filter');
  var rect = document.createElementNS(ns, 'rect');

  filter.setAttribute('id', filterID);

  this.turbSeed = Math.round(Math.random() * 1000);

  var turbulence = document.createElementNS(ns, 'feTurbulence');
  turbulence.setAttribute('baseFrequency', '0.006');
  turbulence.setAttribute('type', 'turbulence');
  turbulence.setAttribute('seed', this.turbSeed);
  turbulence.setAttribute('result', 'turbulenceResult');

  var displacement = document.createElementNS(ns, 'feDisplacementMap');
  displacement.setAttribute('in', 'SourceGraphic');
  displacement.setAttribute('in2', 'turbulenceResult');
  var channels = ['R', 'G', 'B', 'A'];
  var c = Math.floor(Math.random() * 4);
  displacement.setAttribute('xChannelSelector', channels[c]);
  displacement.setAttribute('result', 'displacementResult');

  if(!Modernizr.retina) {
    var blur = document.createElementNS(ns, 'feGaussianBlur');
    blur.setAttribute('in', 'displacementResult');
    blur.setAttribute('stdDeviation', '1');
    blur.setAttribute('result', 'blurResult');

    var blend = document.createElementNS(ns, 'feBlend');
    blend.setAttribute('in', 'displacementResult');
    blend.setAttribute('in2', 'blurResult');
    blend.setAttribute('mode', 'normal');
  }

  rect.setAttribute('filter', 'url("#'+filterID+'")');
  rect.setAttribute('fill', this.color);
  rect.setAttribute('stroke', this.color);
  rect.setAttribute('stroke-width', '1');
  rect.setAttribute('stroke-opacity', '0.5');

  if(this.mode === 'top' || this.mode === 'bottom') {
    turbulence.setAttribute('numOctaves', '4');

    if ( this.mode === 'bottom' ) {
      displacement.setAttribute('scale', '15');
    } else {
      displacement.setAttribute('scale', '25');
    }
  } else {
    turbulence.setAttribute('numOctaves', '10');
    displacement.setAttribute('scale', '6');
  }

  filter.appendChild(turbulence);
  filter.appendChild(displacement);

  if(!Modernizr.retina) {
    filter.appendChild(blur);
    filter.appendChild(blend);
  }

  defs.appendChild(filter);
  svg.appendChild(defs);
  svg.setAttribute('preserveAspectRatio', 'none');

  if(this.mask) {
    var mask = document.createElementNS(ns, 'mask');
    mask.setAttribute('id', maskID);
    mask.appendChild(rect);

    var foreignObject = document.createElementNS(ns, 'foreignObject');
    foreignObject.setAttribute('mask', 'url(#'+maskID+')');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');

    var divStyle = '';

    if(this.mask == 'grain') {
      divStyle = 'height: 100px; background-color: #FCFCF2; background-image: url('+SiteVars['template_url']+'/assets/images/wood-grain-beige.png); background-position: 50% top;';
    } else {
      divStyle = 'height: 100%; background-image: url('+this.mask+'); background-size: cover; background-position: 50% 50%;';
    }

    var div = document.createElement('div');
    div.setAttribute('style', divStyle);

    foreignObject.appendChild(div);

    defs.appendChild(mask);
    svg.appendChild(foreignObject);
  } else {
    svg.appendChild(rect);
  }

  if (this.className) {
    svg.classList.add(this.className);
  }

  this.svg = svg;
  this.turbFilter = turbulence;
  this.rect = rect;
  this.filter = filter;

  if(foreignObject) {
    this.foreignObject = foreignObject;
  }

  if(this.mode === 'bottom' && this.mask) {
    var secondRect = document.createElementNS(ns, 'rect');
    secondRect.setAttribute('fill', this.color);

    this.secondRect = secondRect;
    mask.appendChild(this.secondRect);
  }

  this.active = true;

  this.resize()

  svgID++;

  if(this.$el.is('.vsc-button, .wpslsubmit, .paginate-load-more-button, .acf-form-submit')) {
    this.isSketching = false;

    this.$el
      .on('mouseenter', this.startSketching.bind(this))
      .on('mouseleave', this.stopSketching.bind(this));

    if(device.browser == 'firefox') {
      $(window).on('scroll', debounce(function() {
        this.rect.removeAttribute('filter')
        requestAnimationFrame(function() {
          this.rect.setAttribute('filter', 'url("#'+filterID+'")')
        }.bind(this));
      }.bind(this), 50));
    }
  }
}

RoughEdgeSVG.prototype.resize = function() {
  if(!this.active) {
    return;
  }

  var w = this.el.offsetWidth;
  var h = this.el.offsetHeight;

  if(this.mode === 'bottom') {
    this.svg.setAttribute('viewBox', '0 0 '+w+' '+(h+50));
    this.rect.setAttribute('width', (w+50));
    this.rect.setAttribute('height', 100);
    this.rect.setAttribute('x', '-25');
    this.rect.setAttribute('y', h-75);

    if(this.secondRect) {
      this.secondRect.setAttribute('width', w);
      this.secondRect.setAttribute('height', h-50);
      this.secondRect.setAttribute('x', '0');
      this.secondRect.setAttribute('y', '0');
    }

    if(this.foreignObject) {
      this.foreignObject.setAttribute('width', w);
      this.foreignObject.setAttribute('height', h+50);
      $(this.foreignObject.firstChild).css('height', h+50);
    }

  } else if(this.mode === 'top') {
    this.svg.setAttribute('viewBox', '0 0 '+w+' 100');
    this.rect.setAttribute('width', (w + 50));
    this.rect.setAttribute('height', '100');
    this.rect.setAttribute('x', '-25');
    this.rect.setAttribute('y', '25');

    if(this.foreignObject) {
      this.foreignObject.setAttribute('width', w);
      this.foreignObject.setAttribute('height', '100');
    }
  } else {
    this.svg.setAttribute('viewBox', '0 0 '+w+' '+h);
    this.rect.setAttribute('width', Math.max(w - 8, 0));
    this.rect.setAttribute('height', Math.max(h - 8, 0));
    this.rect.setAttribute('x', '4');
    this.rect.setAttribute('y', '4');

    if(this.foreignObject) {
      this.foreignObject.setAttribute('width', w);
      this.foreignObject.setAttribute('height', h);
      $(this.foreignObject.firstChild).css('height', h+'px');
    }
  }

  // if(!Modernizr.retina && device.browser == 'safari') {
  //   this.filter.setAttribute('filterRes', (w * 4)+' '+(h * 4));
  //   this.turbFilter.setAttribute('baseFrequency', '0.004');
  // }
};

RoughEdgeSVG.prototype.startSketching = function() {
  clearTimeout(this.sketchingTimeout);

  this.isSketching = true;
  this.$el.addClass('in');

  this.sketchingTimeout = setTimeout(this.iterateSketch.bind(this), (1000 / 12));
};

RoughEdgeSVG.prototype.iterateSketch = function() {
  clearTimeout(this.sketchingTimeout);

  this.turbSeed++;

  this.turbFilter.setAttribute('seed', this.turbSeed);

  if(this.isSketching) {
    this.sketchingTimeout = setTimeout(this.iterateSketch.bind(this), (1000 / 12));
  }
};

RoughEdgeSVG.prototype.stopSketching = function() {
  clearTimeout(this.sketchingTimeout);

  this.isSketching = false;

  this.$el.removeClass('in');
};
